const initialDistrict = {
    districts: [],
    districtmessages : {},

};

const districtReducer = (district = initialDistrict, action) => {
    switch (action.type) {
        
        case 'GET_DISTRICT':
        return {
            ...district, districts: action.payload.data
        };
        case 'ADD_DISTRICT':
        return {
            ...district, districtmessages: action.payload.data
        };
        case 'UPDATE_DISTRICT':
        return {
            ...district, districtmessages: action.payload.data
        };
        default:
            return district;
    }
}
export default districtReducer;